<template>
  <div class="kt-login__container">
    <div class="kt-login__logo">
      <img :src="logoImage" alt="Logo" />
    </div>
    <div class="kt-login__signin">
      <div class="kt-login__head">
        <h3 class="kt-login__title">{{ getTitle() }}</h3>
      </div>
      <!--begin::Form-->
      <b-form class="kt-form" @submit.stop.prevent="onSubmit">
        <div role="alert" class="alert alert-info" v-if="showDemoLogin">
          <div class="alert-text">
            Use account
            <strong>admin@demo.com</strong> and password
            <strong>demo</strong> to continue.
          </div>
        </div>

        <div
          role="alert"
          v-bind:class="{ show: errors.length }"
          class="alert fade alert-danger"
          v-if="errors.length"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <b-form-group id="username-group" label label-for="username">
          <b-form-input
            id="username"
            name="username"
            v-model="$v.form.username.$model"
            :state="validateState('username')"
            aria-describedby="username-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="username-live-feedback">
            Email is required and a valid email address.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="password-group" label label-for="password">
          <b-form-input
            type="password"
            id="password"
            name="password"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="password-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="password-live-feedback"
            >Password is required.</b-form-invalid-feedback
          >
        </b-form-group>

        <div class="row kt-login__extra">
          <div class="col">
            <label class="kt-checkbox" v-show="false">
              <input type="checkbox" name="remember" /> Remember me
              <span></span>
            </label>
          </div>
          <div class="col kt-align-right">
            <a
              href="javascript:;"
              id="kt_login_forgot"
              class="kt-link kt-login__link-forgot"
              >{{ $t("AUTH.FORGOT.TITLE") }}</a
            >
          </div>
        </div>

        <!--begin::Action-->
        <div class="kt-login__actions">
          <b-button
            type="submit"
            id="kt_submit"
            class="btn btn-primary btn-elevate kt-login__btn-primary"
            :class="
              isBusy ? 'kt-spinner kt-spinner--light kt-spinner--right' : ''
            "
            :disabled="isBusy"
            >{{ $t("AUTH.LOGIN.BUTTON") }}</b-button
          >
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <div class="kt-login__account" v-if="allowRegister">
      <span class="kt-login__account-msg">Don't have an account yet ?</span>
      &nbsp;&nbsp;
      <router-link
        :to="signUpLink"
        id="kt_login_signup"
        class="kt-login__account-link"
        >Sign Up!</router-link
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>
import { mapState, mapGetters } from "vuex";
import { LOGIN, CLEAR_AUTH } from "@/store/auth.module";
import { APP_CONFIG } from "@/common/config";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      showDemoLogin: false,
      socialLogin: false,
      sectionData: {
        default: {
          title: "User Login"
        },
        admin: {
          title: "Admin Login"
        },
        affiliate: {
          title: "Affiliate Login"
        },
        vendor: {
          title: "Vendor Login"
        }
      },
      // Remove this dummy login info
      form: {
        username: "binarygeotech@gmail.com",
        password: "@Password123"
      },
      isBusy: false
    };
  },
  validations: {
    form: {
      username: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;

      this.isBusy = true;

      // clear existing errors
      this.$store.dispatch(CLEAR_AUTH);

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");

      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      // send login request
      this.$store
        .dispatch(LOGIN, { username, password })
        // go to which page after successfully login
        .then(() => {
          const prefix =
            this.getSection === "default" ? "" : this.getSection + "-";

          this.$router.push({ name: `${prefix}dashboard` });
        })
        .catch(() => (this.isBusy = false))
        .then(() => (this.isBusy = false));

      submitButton.classList.remove(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );
    },
    getTitle() {
      return this.sectionData[this.getSection].title;
    }
  },
  computed: {
    ...mapGetters(["getSection", "isAuthenticated"]),
    ...mapState({
      errors: state => (state.auth.errors ? state.auth.errors : [])
    }),
    logoImage() {
      const appLogo = APP_CONFIG.app_logo;

      return appLogo.startsWith("http")
        ? appLogo
        : process.env.BASE_URL + appLogo;
    },
    allowRegister() {
      return this.getSection !== "admin"; // && this.getSection !== "default";
    },
    signUpLink() {
      // return "register";
      // return this.getSection === "default"
      //   ? "auth/register"
      //   : `${this.getSection}/auth/register`;
      return this.getSection === "default"
        ? { name: "register" }
        : { name: `${this.getSection}-register` };
    }
  }
};
</script>
